module.exports = __webpack_public_path__ + "img/tm.bdd29cb.svg";